import {AxiosInstance} from "axios"
import {responseHandler} from "./response"
import {ApiSportsEndPointResponse} from "./types"
import {PlanOffer} from "../../types/transaction"

/**
 * The plans as they are actually sold.
 *
 * Read from the API rather than from the bundle: prices, limits and wording are edited from the
 * admin dashboard, and a pricing page built from constants would keep quoting yesterday's prices.
 */
export const getPlans = async (client: AxiosInstance, sellableOnly = true) => {
    client.defaults.params = sellableOnly ? {sellable: "true"} : {}
    return responseHandler<ApiSportsEndPointResponse<PlanOffer>>(client.get("/plans"))
}
